import { COURSE_FINAL_QUIZ_UNLOCK_PERCENT } from "@/lib/courseFinalQuiz";
import type { CompletionQuizStartError } from "@/types/courseCompletionQuiz";

/** What to tell a learner when the quiz could not be started. */
export const startErrorMessage = (
  error: CompletionQuizStartError,
  unlockPercent: number = COURSE_FINAL_QUIZ_UNLOCK_PERCENT
): string => {
  switch (error) {
    case "locked":
      return `Das Kursabschlussquiz ist noch gesperrt. Es öffnet sich ab ${unlockPercent} % Lernfortschritt.`;
    case "waiting":
      return "Dein letzter Versuch ist noch nicht lange her. Bitte warte, bis die Pause vorbei ist.";
    case "passed":
      return "Du hast das Kursabschlussquiz bereits bestanden.";
    case "failed_final":
      return "Du hast alle Versuche genutzt. Ein weiterer Versuch ist nicht möglich.";
    case "no_quiz":
    case "no_questions":
      return "Dieser Kurs hat kein Kursabschlussquiz, das du starten kannst.";
  }
};
